let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bYWK5")).then(() => parcelRequire('cDjZR'));